import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=6b6fa488&scoped=true"
import script from "./Secure.vue?vue&type=script&lang=js"
export * from "./Secure.vue?vue&type=script&lang=js"
import style0 from "./Secure.vue?vue&type=style&index=0&id=6b6fa488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6fa488",
  null
  
)

export default component.exports